import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box, Button, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePublicationCompatiblePagination, {
  usePublicationCompatiblePaginationForm,
} from '@hooks/usePublicationCompatiblePagination'
import usePublicationCompatiblePaginations from '@hooks/usePublicationCompatiblePaginations'

import EntitySelector from '@components/EntitySelector'

const CreatePublicationCompatiblePaginationModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, createPublicationCompatiblePagination } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { publicationCompatiblePagination } = modalPayload

  const {
    filteredCompatiblePublicationIds,
  } = usePublicationCompatiblePaginations({
    filters: { publication_id: publicationCompatiblePagination.publication_id },
  })

  const {
    callbacks: { createPublicationCompatiblePagination: createFn },
    creating,
  } = usePublicationCompatiblePagination()

  const {
    entityState,
    entityState: {
      compatible_publication_id,
      publication_id,
    },
    errors,
    saveEnabled,
    setEntityState,
  } = usePublicationCompatiblePaginationForm(publicationCompatiblePagination)

  const createPublicationCompatiblePaginationPayload = {
    callbacks: {
      action: createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Compatible Pagination Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Compatible" titleSecondLine="Pagination" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <EntitySelector
            callbacks={{
              selectItem: publication => (
                setEntityState({ compatible_publication_id: publication ? publication.id : null })
              ),
            }}
            entityKey="publications"
            errorMessage={errors.compatible_publication_id}
            label="* Compatible Publication"
            name="compatible_publication_id"
            selectedIds={[...filteredCompatiblePublicationIds, publication_id]}
            selectedItemId={compatible_publication_id}
          />
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          onClick={() => createPublicationCompatiblePagination(createPublicationCompatiblePaginationPayload)}
          size="large"
        >
          {saveEnabled ? 'Create Compatible Pagination' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreatePublicationCompatiblePaginationModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

CreatePublicationCompatiblePaginationModal.defaultProps = {
  modalKey: 'CreatePublicationCompatiblePaginationModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreatePublicationCompatiblePaginationModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
